export const getUrlParam = (paramName: string): string | null => {
  // First try standard search params
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has(paramName)) {
    return searchParams.get(paramName);
  }

  // Fallback: check if the parameters are appended to the path itself
  // e.g. /moje-konto/tab=przeloz&order_id=123 (missing ?)
  const pathPart = window.location.href.split('/').pop() || '';
  if (pathPart.includes(`${paramName}=`)) {
    const fallbackParams = new URLSearchParams(pathPart);
    return fallbackParams.get(paramName);
  }

  return null;
};
